import { ABOUT_FAQ } from "@/content/about-content";
/** JSON-LD @graph emitted on /about. Verbatim move from the route file. */
export const aboutGraphSchema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "ProfilePage",
      "@id": "https://freelancertamal.com/about#profilepage",
      url: "https://freelancertamal.com/about",
      name: "About Freelancer Tamal — SEO Expert in Bangladesh",
      description:
        "Profile of Freelancer Tamal — senior SEO, AEO & GEO consultant based in Rangpur, Bangladesh.",
      inLanguage: "en",
      // dateModified injected at use-site so the editorial date stays a single source of truth.
      mainEntity: { "@id": "https://freelancertamal.com/#person" },
      about: { "@id": "https://freelancertamal.com/#person" },
      breadcrumb: {
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "Home", item: "https://freelancertamal.com/" },
          { "@type": "ListItem", position: 2, name: "About", item: "https://freelancertamal.com/about" },
        ],
      },
      isPartOf: { "@id": "https://freelancertamal.com/#website" },
    },
    {
      "@type": "Person",
      "@id": "https://freelancertamal.com/#person",
      name: "Freelancer Tamal",
      alternateName: "Tamal",
      url: "https://freelancertamal.com/about",
      image: "https://freelancertamal.com/tamal-portrait.webp",
      jobTitle: "SEO Expert",
      description:
        "SEO, AEO and GEO consultant based in Rangpur, Bangladesh.",
      email: "admin@freelancertamal.com",
      telephone: "+8801777591051",
      address: {
        "@type": "PostalAddress",
        streetAddress: "House #152, Road #3, Mayamoyi Sorok, Kamal Kachna",
        addressLocality: "Rangpur",
        addressRegion: "Rangpur Division",
        postalCode: "5400",
        addressCountry: "BD",
      },
      contactPoint: [
        {
          "@type": "ContactPoint",
          telephone: "+8801777591051",
          contactType: "customer support",
          email: "admin@freelancertamal.com",
          areaServed: ["BD", "Worldwide"],
          availableLanguage: ["English", "Bengali"],
        },
      ],
      knowsAbout: [
        "Search Engine Optimization",
        "Technical SEO",
        "Local SEO",
        "E-commerce SEO",
        "Shopify SEO",
        "Generative SEO",
        "Answer Engine Optimization",
        "Keyword Research",
      ],
      worksFor: {
        "@type": "Organization",
        "@id": "https://freelancertamal.com/#business",
        name: "Freelancer Tamal",
      },
      brand: { "@id": "https://freelancertamal.com/#business" },
      sameAs: [
        "https://www.linkedin.com/company/freelancer-tamal/",
        "https://www.facebook.com/freelancertamal/",
        "https://youtube.com/@freelancertamal",
        "https://share.google/0wxWoHi4niDKQOFyH",
        // Author entity expansion — paste real URLs here as they go live to
        // strengthen Person entity recognition in Google's Knowledge Graph
        // and across LLM training/retrieval indexes. Each added URL is a
        // strong disambiguation signal.
        // TODO: "https://github.com/<handle>",
        // TODO: "https://twitter.com/<handle>" (or https://x.com/<handle>),
        // TODO: "https://www.crunchbase.com/person/<slug>",
        // TODO: "https://<handle>.medium.com" or Substack URL,
        // TODO: "https://www.wikidata.org/wiki/Q<id>",
        // TODO: "https://www.searchenginejournal.com/author/<slug>/",
        // TODO: SEO BD Conference speaker page URL,
      ],
    },
    {
      "@type": "LocalBusiness",
      "@id": "https://freelancertamal.com/#business",
      name: "Freelancer Tamal — SEO Expert",
      image: "https://freelancertamal.com/tamal-portrait.webp",
      url: "https://freelancertamal.com",
      telephone: "+8801777591051",
      email: "admin@freelancertamal.com",
      priceRange: "$$",
      address: {
        "@type": "PostalAddress",
        streetAddress: "House #152, Road #3, Mayamoyi Sorok, Kamal Kachna",
        addressLocality: "Rangpur",
        addressRegion: "Rangpur Division",
        postalCode: "5400",
        addressCountry: "BD",
      },
      contactPoint: [
        {
          "@type": "ContactPoint",
          telephone: "+8801777591051",
          contactType: "sales",
          email: "admin@freelancertamal.com",
          areaServed: ["BD", "Worldwide"],
          availableLanguage: ["English", "Bengali"],
        },
      ],
      geo: {
        "@type": "GeoCoordinates",
        latitude: 25.7439,
        longitude: 89.2752,
      },
      areaServed: ["Rangpur", "Bangladesh", "Worldwide"],
      founder: { "@id": "https://freelancertamal.com/#person" },
      sameAs: [
        "https://share.google/0wxWoHi4niDKQOFyH",
        "https://www.linkedin.com/company/freelancer-tamal/",
        "https://www.facebook.com/freelancertamal/",
      ],
    },
    {
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "Home", item: "https://freelancertamal.com/" },
        { "@type": "ListItem", position: 2, name: "About", item: "https://freelancertamal.com/about" },
      ],
    },
    {
      "@type": "FAQPage",
      mainEntity: [
        { "@type": "Question", name: "Who is the best SEO expert in Bangladesh?", acceptedAnswer: { "@type": "Answer", text: "Choose an SEO consultant by relevant work, dated evidence, clear scope and reporting access rather than unsupported superiority claims." } },
        { "@type": "Question", name: "How long does it take to see SEO results?", acceptedAnswer: { "@type": "Answer", text: "Most clients begin seeing measurable improvements in organic traffic and rankings within 6 to 12 months." } },
        { "@type": "Question", name: "Can SEO grow my business locally and globally?", acceptedAnswer: { "@type": "Answer", text: "Yes. The same fundamentals that win Rangpur map-pack rankings scale up to multinational SaaS and ecommerce — only the tactics differ." } },
      ],
    },
  ],
} as const;

/**
 * Localised variant of the About graph. Pass `localize` to emit the same
 * entity graph for a translated page (e.g. /bn/about): the ProfilePage,
 * BreadcrumbList, and FAQPage nodes get language-specific URLs and copy while
 * the Person and LocalBusiness entities stay shared (same @id) so both
 * languages reinforce one entity rather than creating a duplicate.
 */
export function buildAboutGraph(
  reviewedOn: string,
  localize?: {
    path: string;
    language: string;
    name: string;
    description: string;
    breadcrumb: { name: string; path: string }[];
    faq: { q: string; a: string }[];
  },
) {
  const base = "https://freelancertamal.com";
  const graph = (aboutGraphSchema["@graph"] as ReadonlyArray<Record<string, unknown>>).map((node) => {
    const type = (node as { "@type"?: string })["@type"];
    if (type === "ProfilePage") {
      if (!localize) return { ...node, dateModified: reviewedOn };
      return {
        ...node,
        "@id": `${base}${localize.path}#profilepage`,
        url: `${base}${localize.path}`,
        name: localize.name,
        description: localize.description,
        inLanguage: localize.language,
        dateModified: reviewedOn,
        breadcrumb: {
          "@type": "BreadcrumbList",
          itemListElement: localize.breadcrumb.map((b, i) => ({
            "@type": "ListItem",
            position: i + 1,
            name: b.name,
            item: `${base}${b.path}`,
          })),
        },
      };
    }
    if (localize && type === "BreadcrumbList") {
      return {
        "@type": "BreadcrumbList",
        itemListElement: localize.breadcrumb.map((b, i) => ({
          "@type": "ListItem",
          position: i + 1,
          name: b.name,
          item: `${base}${b.path}`,
        })),
      };
    }
    if (type === "FAQPage") {
      // Always mirror the visible FAQ so structured data never drifts from page copy.
      const faq = localize ? localize.faq : ABOUT_FAQ;
      return {
        "@type": "FAQPage",
        inLanguage: localize ? localize.language : "en",
        mainEntity: faq.map((f) => ({
          "@type": "Question",
          name: f.q,
          acceptedAnswer: { "@type": "Answer", text: f.a },
        })),
      };
    }
    return node;
  });
  return { "@context": "https://schema.org", "@graph": graph };
}